// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../../index';

import { gql } from 'graphql-tag';
import { FilterPriceRangeFragmentDoc } from '../../fragments/filters/filterPriceRange.fragment.generated';
import { FilterWeddingRingStyleFragmentDoc } from '../../fragments/filters/filterWeddingRingStyle.fragment.generated';
import { FilterWeddingRingCategoryFragmentDoc } from '../../fragments/filters/filterWeddingRingCategory.fragment.generated';
import { MetalFilterFragmentDoc } from '../../fragments/filters/metalFilter.fragment.generated';
export const WeddingRingFiltersFragmentDoc = gql`
    fragment weddingRingFilters on CatalogueWeddingRingFilters {
  price(input: {currency: $currency, country: $country}) {
    ...filterPriceRange
  }
  ringStyles {
    ...filterWeddingRingStyle
  }
  categories {
    ...filterWeddingRingCategory
  }
  primaryMetals {
    ...metalFilter
  }
}
    ${FilterPriceRangeFragmentDoc}
${FilterWeddingRingStyleFragmentDoc}
${FilterWeddingRingCategoryFragmentDoc}
${MetalFilterFragmentDoc}`;